import { ACL_REQUEST, ACL_ERROR, ACL_SUCCESS, ACL_RESET } from '../actions/acl'
import { getUserACLs, setUserACLs, unsetUserACLs } from '../persist/acl.js'
// import axios from 'axios'
import axios from '../../lib/backend/axios'
const state = { status: '', acls: {} }

const getters = {
	getUserACLs: state => state.acls,
}


const actions = {
	[ACL_REQUEST]: ({ commit, dispatch }) => {
		commit(ACL_REQUEST)
		let res = getUserACLs() 
		if(res){
			commit(ACL_SUCCESS, res)
		}
		else {
			axios.get("/account/acls", { headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken')}})
				.then(resp => {
					setUserACLs(resp.data)
					console.log(resp.data)
					commit(ACL_SUCCESS, resp.data)
				})
				.catch(resp => {
					commit(ACL_ERROR)
					// if resp is unauthorized, logout, to
				})
			}
	},
	[ACL_RESET]: ({ commit, dispatch }) => {
		commit(ACL_RESET)
		unsetUserACLs()

	},
}

const mutations = {
	[ACL_REQUEST]: (state) => {
		state.status = 'loading'
	},
	[ACL_SUCCESS]: (state, resp) => {
		state.status = 'success'
		state.acls = resp
	},
	[ACL_ERROR]: (state) => {
		state.status = 'error'
	},
	[ACL_RESET]: (state) => {
		Vue.set(state, 'acls', {})
	}
}

export default {
	state,
	getters,
	actions,
	mutations,
}
